
<header class="masthead" style="background-color:#1cd5db;">
    <div class="container">
        <div class="row">
            <div class="col-lg-8 col-md-10 mx-auto" style="font-family: 'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif;">
                <div class="site-heading" style="padding: 28px 0;">

                </div>
            </div>
        </div>
    </div>
</header>
<div class="row">
	<div class="col-md-6 offset-md-3 mt-4">
		<h3>Email Confirmation Page</h3>
		<div class="alert alert-primary" *ngIf="emailConfirmed" role="alert">
			Email confirmed
		</div>
		<div class="alert alert-warning" *ngIf="!emailConfirmed" role="alert">
			Unable to confirm email
		</div>
		
	</div>
</div>
<div class="row">
	<div class="col-md-6 offset-md-3 mt-4 text-center">
			<a class="btn btn-secondary text-white" 
			style="border-radius:0;border:none;background-color:#1cd5db;margin-right:2%"
			[routerLink]="['']" 
			routerLinkActive="active">
			<i class="fas fa-home"></i> Go to home page</a>
	
			<a class="btn btn-secondary text-white" 
			style="border-radius:0;border:none;background-color:#1cd5db"
			[routerLink]="['/login']" 
			routerLinkActive="active">
			<i class="fas fa-sign-in-alt"></i> Login</a>
	</div>
</div>
<br />
<br />
<br />
<br />
<br />
<br />
<br />
<br />
<br />
<br />
<br />
<br />
<br /><br />
<br /><br />
<br />
<br />
<br />
